import datepicker, { type DatepickerInstance } from "js-datepicker";
import type { DOB } from "./dob";

export function setupDatePicker({
  dob,
  dobDay,
  dobMonth,
  dobYear,
}: DOB): DatepickerInstance {
  const parent = dob.parentNode!.parentNode!;

  const picker: DatepickerInstance = datepicker(
    parent.querySelector("[data-datepicker]")! as HTMLElement,
    {
      position: "br",
      customDays:
        document.documentElement.lang === "uk"
          ? ["пн", "вт", "ср", "чт", "пт", "сб", "нд"]
          : undefined,
      customMonths:
        document.documentElement.lang === "uk"
          ? [
              "сичень",
              "лютий",
              "березень",
              "квітень",
              "травень",
              "червень",
              "липень",
              "серпень",
              "вересень",
              "жовтень",
              "листопад",
              "грудень",
            ]
          : undefined,
      customOverlayMonths:
        document.documentElement.lang === "uk"
          ? [
              "сич",
              "лют",
              "берез",
              "квіт",
              "трав",
              "черв",
              "лип",
              "серп",
              "верес",
              "жовт",
              "листоп",
              "груд",
            ]
          : undefined,
      overlayPlaceholder:
        document.documentElement.lang === "uk" ? "рік" : undefined,
      overlayButton:
        document.documentElement.lang === "uk" ? "зберегти" : undefined,
      onSelect: (instance: typeof picker, date: Date) => {
        dobDay.value = date.getDate().toString();
        dobMonth.value = (date.getMonth() + 1).toString();
        dobYear.value = date.getFullYear().toString();
        dob!.value = `${dobYear.value}-${dobMonth.value.padStart(2, "0")}-${dobDay.value.padStart(2, "0")}`;
        dob.dispatchEvent(new Event("change"));
      },
    },
  );
  picker.calendarContainer.style.setProperty("font-family", "Tektur");

  return picker;
}
